export const money = (n) => `£${Number(n || 0).toFixed(2)}`;

export const CONTACT_EMAIL = "michael@newhamemergencylocksmiths.co.uk";

export const contactHref = (p) => `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(`Warrant Whizz ${p.name} plan`)}`;

export const priceLabel = (p) => p.price_text || (p.price ? money(p.price) : "Contact us");

export const showPerMonth = (p) => !p.price_text && !!p.price;

export const limitLines = (p) => [
  p.basic ? "Runs assigned to you only" : (p.max_locksmiths ? `Up to ${p.max_locksmiths} locksmith${p.max_locksmiths === 1 ? "" : "s"}` : "Unlimited locksmiths"),
  p.max_runs_per_month ? `Up to ${p.max_runs_per_month} warrant runs a month` : "Unlimited warrant runs",
];

export const extrasLine = (p) => (p.basic ? "Exports and lock change reports (no maps)" : "Maps, exports and lock change reports");

export const planBullets = (p, extra = []) => (p.features?.length ? p.features : [...limitLines(p), extrasLine(p), ...(p.display_only ? [] : extra)]);
